export default "__VITE_ASSET__Dk7QJDfl__"